<div class="bg-banner-gradient relative md:mt-[64px] bg-cover bg-center min-h-[200px]">
  <div id="banner" class="container mx-auto max-w-[1240px] lg:max-w-[1240px] 2xl:max-w-[1570px] flex md:flex-row flex-col relative bg-cover bg-center h-auto min-h-52 items-center justify-between p-4 b-8">
    <div class="flex flex-col justify-center md:w-1/2 text-white text-center md:text-start font-inter z-10">
      <h1 class="text-2xl font-semibold mb-3 text-white">Hola usuario,</h1>
      <p class="text-xl font-semibold text-white">Tu espacio Griky</p>
      <p class="w-full description-2">
        Bienvenue dans l'espace de formation digital d'Apside. Vous voulez en savoir plus sur notre groupe !
        Cliquez sur le lien ci-dessous pour
      </p>
    </div>

    <div class="cards-banner flex md:flex-row gap-4 mt-6 md:mt-0 md:ml-10 z-10">
      <div class="bg-white bg-opacity-10 py-4 px-5 rounded-[14px] shadow-lg w-full md:w-60 text-start">
        <i class="rounded-[6px] bg-white bg-opacity-10 py-2 px-3 shadow-lg fa fa-link text-gray-300 fa-sm text-sm mb-2"></i>
        <a href="#" class="block text-white hover:underline text-md font-semibold text-primary-500">Ir a mi perfil académico</a>
        <a href="#" class="block text-white hover:underline text-sm text-primary-500">Impulsa tu perfil</a>
      </div>
      <div class="bg-white bg-opacity-10 py-4 px-5 rounded-[14px] shadow-lg w-full md:w-60 text-start">
        <i class="fa fa-clock rounded-[6px] bg-white bg-opacity-10 py-2 px-3 shadow-lg text-gray-300 fa-sm text-sm mb-2"></i>
        <a href="#" class="block text-white hover:underline text-md font-semibold text-primary-500">12 horas de aprendizaje</a>
        <a href="#" class="block text-white hover:underline text-sm text-primary-500">5 cursos completados</a>
      </div>
    </div>
  </div>
</div>